// ============================================================================
// NOTICE RETURN STATUS ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const NOTICE_RETURN_STATUS_BASE_PATH = '/NoticeReturnStatus';

export const noticeReturnStatusEndpoints = {
  list: () => buildEndpoint(NOTICE_RETURN_STATUS_BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${NOTICE_RETURN_STATUS_BASE_PATH}/:id`, { id }),
  getByCode: (code: string) => buildEndpointWithParams(`${NOTICE_RETURN_STATUS_BASE_PATH}/code/:code`, { code }),
  create: () => buildEndpoint(NOTICE_RETURN_STATUS_BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${NOTICE_RETURN_STATUS_BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${NOTICE_RETURN_STATUS_BASE_PATH}/:id`, { id }),
  validateCode: (code: string) => buildEndpointWithParams(`${NOTICE_RETURN_STATUS_BASE_PATH}/validate/code/:code`, { code }),
} as const;

export default noticeReturnStatusEndpoints;
